import { useCallback } from 'react';

export function useOnEnterKey(fn: () => void): React.KeyboardEventHandler<HTMLInputElement> {
  return useCallback(
    ({ key }) => {
      if (key === 'Enter') {
        fn();
      }
    },
    [fn]
  );
}

export function useOnInputChange(fn: (newVal: string) => void): React.ChangeEventHandler<HTMLInputElement> {
  return useCallback(
    ({ currentTarget: { value } }) => {
      fn(value);
    },
    [fn]
  );
}
